import React, { useState, useEffect, useRef } from "react";
import SyncIcon from "../../../../../assets/svg/solobuilder/SyncIcon";
import DownArrow from "../../../../../assets/svg/solobuilder/DownArrow";

type Props = {
    componentIdsToUpdate?: string[];
    deviceType: string;
    changeTo?: string;
    syncTo: string;
    handleSync: (syncDetails: any) => void;
};

const SyncStyle: React.FC<Props> = ({ deviceType, syncTo, handleSync }) => {
    const [openSyncStyles, setOpenSyncStyles] = useState<boolean>(false);
    const syncStylesDrop = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const closeDropdown = (e: MouseEvent) => {
            if (
                syncStylesDrop.current &&
                !syncStylesDrop.current.contains(e.target as Node)
            ) {
                setOpenSyncStyles(false);
            }
        };
        document.body.addEventListener("click", closeDropdown);
        return () => document.body.removeEventListener("click", closeDropdown);
    }, []);

    const menuItems = [
        { label: "To all form devices", changeTo: "All", condition: true },
        { label: "To desktop", changeTo: "Lg", condition: deviceType !== "Lg" },
        { label: "To tablet", changeTo: "Md", condition: deviceType !== "Md" },
        { label: "To mobile", changeTo: "Sm", condition: deviceType !== "Sm" },
    ];

    const styles = {
        button: {
            marginTop: "10px",
            border: "1px solid #7D84924B",
            borderColor: openSyncStyles?"#f1722e":"#7D84924B"
        },
        buttonContent: {
            color: "#282B31",
            fontSize: "11px",
            lineHeight: "14px",
        },
        dropdown: {
            marginTop: "5px",
            border: "1px solid #7D84924B",
            minWidth: "160px",
            boxShadow: "rgba(125, 132, 146, 0.11) 0px 5px 8px"
        },
        menuItem: {
            color: "#282B31",
            fontSize: "11px",
            lineHeight: "14px",
        },
        menuItemHeader: {
            color: "#667085D6",
            fontSize: "11px",
            lineHeight: "14px",
            marginTop: "10px",
            padding: "0px 10px 6px",
        },
        menuItemLink: {
            padding: "6px 10px",
        },
    };

    return (
        <div className="relative bg-white" ref={syncStylesDrop}>
            {syncTo === "ALL" ? (
                <SyncIcon
                    title="SyncStyles"
                    style={{
                        backgroundColor: openSyncStyles
                            ? "#052f35 "
                            : "#95ABD34B",
                    }}
                    height="30px"
                    width="30px"
                    className="cursor-pointer p-2 rounded-lg"
                    onClick={() => setOpenSyncStyles(!openSyncStyles)}
                    stroke={openSyncStyles ? "#ffffff" : "#052f35 "}
                />
            ) : (
                <button
                    style={{...styles.button, outline: "none", borderRadius: "2px"}}
                    className="flex items-center justify-between w-full p-2.5"
                    onClick={() => setOpenSyncStyles(!openSyncStyles)}
                >
                    <div className="flex items-center">
                        <SyncIcon className="mr-1.5 text-lg" />
                        <span
                            className="font-semibold"
                            style={styles.buttonContent}
                        >
                            Sync Styles
                        </span>
                    </div>
                    <div
                        style={{
                            transform: openSyncStyles
                                ? "rotate(0deg)"
                                : "rotate(-90deg)",
                            transition: "transform 150ms ease-in-out",
                        }}
                    >
                        <DownArrow />
                    </div>
                </button>
            )}

            {openSyncStyles && (
                <div
                    style={styles.dropdown}
                    className="absolute z-20 w-full bg-white rounded-lg right-0 origin-top-right"
                >
                    <ul className="font-semibold mb-2.5">
                        <li style={styles.menuItemHeader}>APPLY STYLES:</li>
                        {menuItems.map(
                            (item) =>
                                item.condition && (
                                    <li
                                        key={item.changeTo}
                                        style={styles.menuItem}
                                    >
                                        <a
                                            onClick={() => {
                                                setOpenSyncStyles(
                                                    !openSyncStyles
                                                );
                                                handleSync(
                                                    syncTo === "CANVAS"
                                                        ? {
                                                              syncTo,
                                                              deviceType,
                                                              changeTo:
                                                                  item.changeTo,
                                                          }
                                                        : item.changeTo
                                                );
                                            }}
                                            style={styles.menuItemLink}
                                            className="block hover:bg-gray-100"
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                )
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default SyncStyle;
